import * as Yup from 'yup';

const emptyError = 'Por favor llena todos los campos antes de continuar';

export  const schemapass = Yup.object().shape({
    password: Yup
    .string()
    .label('Password')
    .required()
    .min(2, 'Seems a bit short...')
    .max(10, 'We prefer insecure system, try a shorter password.'),
  confirmPassword: Yup
    .string()
    .required()
    .label('Confirm password')
    .test('passwords-match', 'Passwords must match ya fool', function(value) {
      return this.parent.password === value;
    }),
});




export const schema2 = Yup.object().shape({
    email: Yup.string().email('Por favor, llenar el campo con un correo valido.')
        .required(emptyError)
});